export default function () {
  let $bg = $('.js-dark-elm');
  let $target = $('.js-over-check');
  let $disableSP = $('.js-disable-sp');
  let $header = $('.js-l-header:eq(0)');

  if($target.length < 1) {
    return;
  }

  function setPos() {
    $bg.each(function () {
      $(this).data({
        'top': $(this).offset().top,
        'btm': $(this).offset().top + $(this).height()
      });
    });
    $disableSP.each(function () {
      $(this).data({
        'top': $(this).offset().top,
        'btm': $(this).offset().top + $(this).height()
      });
    });
  }

  $(window).on('resize', setPos);

  $(window).on('scroll', function() {

    let tgTop = $target.offset().top;

    $bg.each(function () {
      if (tgTop >= $(this).data('top') && tgTop <= $(this).data('btm')) {
        $header.addClass('is-on');
      } else {
        $header.removeClass('is-on');
      }
    });

    if( $('.u-hidden-gtTAB').css('display') !== 'none' ) {
      $disableSP.each(function () {
        if (tgTop >= $(this).data('top') && tgTop <= $(this).data('btm')) {
          $header.removeClass('is-on');
        }
      });
    }

  })
}
